module.exports = __webpack_public_path__ + "media/images/industrial-workers-2ad30943e3568ab8a51b7e89b6cc68f5.png";